import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';

import { operacion } from '../movimientos/movimientos.component';
import { Empresa, ComprobanteE, Query, Bitacora } from 'app/finanzas/entidades';

import { FinanzasService } from 'app/finanzas/finanzas.service';

import { FormComprobanteComponent } from 'app/finanzas/modals/form-comprobante/form-comprobante.component';

import Swal from 'sweetalert2';

import { ConsultaFechaComponent } from 'app/finanzas/modals/consultaFecha/consultaFecha.component';
import { RelGastos } from 'app/finanzas/modals/relGastos/relGastos.component';


@Component({
  selector: 'app-comprobantex-anio',
  templateUrl: './comprobantex-anio.component.html',
  styleUrls: ['./comprobantex-anio.component.css']
})
export class ComprobantexAnioComponent implements OnInit {

  // variables paginadores 
  p1 : number = 1;
  p2 : number = 1;
  p3 : number = 1;
  p4 : number = 1;
  p5 : number = 1;
  p6 : number = 1;
  p7 : number = 1;
  p8 : number = 1;
  p9 : number = 1;
  p10 : number = 1;
  p11 : number = 1;
  p12 : number = 1;

  comprobante : ComprobanteE = new ComprobanteE()
  movimiento : Bitacora = new Bitacora()

  comprobantes: Array<ComprobanteE>;   // Array que contiene

  id_empresa: any;
  nombreEmpresa: any;
  diferenciaCE_MC: any; 

  anio:number;
  areas;
  puc;
  
  constructor(
            private router: ActivatedRoute,
            private servicio: FinanzasService,
            private dialog : MatDialog,
  ) { 
    this.router.queryParams.subscribe(( params )=> {
      this.id_empresa = params.empresa;
      this.anio = params.anio;
    })
    this.comprobantes = [];
  }

  ngOnInit() {    
    this.servicio.filtroComprobanteAnio(this.id_empresa, this.anio)
      .subscribe( (resp :Array<ComprobanteE> ) => {
          this.comprobantes = resp;
      })
    this.tablaEmpresas()
    this.diferenciaCE()
    
  }

  tablaEmpresas() { this.servicio.getEmpresaId(this.id_empresa)
      .subscribe( (  [resp]:Array<Empresa>  ) => { 
        this.nombreEmpresa = resp.Empresa;  
      })
  }

  private diferenciaCE() { 
    this.servicio.diferencia2(this.id_empresa, this.anio)
      .subscribe(([resp]: Array<operacion>) => {
        this.diferenciaCE_MC = resp.resultado 
    }) 
  }


  totales(){
    return this.comprobantes.map(t => t.monto).reduce( (acc, value) => acc + value, 0)
  }


  totalMes(mes) {
    var total: number = 0;
    for (const i of this.comprobantes) {
      if (i.mes == mes) {
        total = i.monto + total
      }
    }
    return total
  }

  formComprobante( idComprobante, mes): void {
    const dialogRef = this.dialog.open( FormComprobanteComponent, {
      width: '500px',
      data :{
        idComprobante,
        mes,
        anio: this.anio,
        empresa: this.id_empresa, 
        comprobantes: this.comprobantes,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
        this.comprobante = result;
        this.guardar()
    });
  }

  relacionarGastos(idComprobante, mes):void{
    const dialogRef = this.dialog.open(RelGastos, {
      width:'430px', 
      data:{
        idComprobante, 
        mes,  
        empresa: this.id_empresa, 
        anio:this.anio,       
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    
    })
  }

  

  AbrirModal(): void {
    const dialogRef = this.dialog.open(ConsultaFechaComponent, {
      width: '450px',
      data: {
        empresa: this.id_empresa,
      }
    });

    dialogRef.afterClosed().subscribe(result => {     
      this.ngOnInit()
    });
  }


  eliminarRegistro( item ){
    Swal.fire({
      title: '¿Esta seguro que desea eliminar este registro?',
      type: 'warning',
      showCancelButton:true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si'

    }).then((result) => {
      if (result.value) {
        this.comprobante = item;
        this.comprobante['estado'] = 0;
        this.servicio.borrarBitacoraCE(this.comprobante, item.idComprobante)
          .subscribe( (resp:Query) => {
          if( resp.affectedRows != 0 ){
            Swal.fire(
              'Eliminado',
              'El archivo fue eliminado correctamente',
              'success'
            )}
            this.servicio.filtroComprobanteAnio(this.id_empresa, this.anio)
              .subscribe( (resp :Array<ComprobanteE> ) => {                
                this.comprobantes = resp;
            })
        })
      }
    })
  }
  
  guardar() { 
    if (this.comprobante['idComprobante'] != undefined){
      this.servicio.updateComprobante(this.comprobante, this.comprobante['idComprobante'])
          .subscribe( (status:Query ) => {
            const affectedRows = status.affectedRows 
            if (affectedRows != 0){
              Swal.fire({
                type:'success', 
                title: 'Registro Actualizado',
              })
            }
            this.servicio.filtroComprobanteAnio(this.id_empresa, this.anio)
              .subscribe( (resp  :Array<ComprobanteE>)  => {
                this.comprobantes = resp
            })
          });
    }
    else {
      this.servicio.insertComprobante(this.comprobante)
        .subscribe(  (status:Query)  => {
          const id_insert = status.insertId;

          if(id_insert != 0){
            Swal.fire({
              type:  'success',
              title:  'Regsitro Guardado',
            })
            this.servicio.filtroComprobanteAnio(this.id_empresa, this.anio)
              .subscribe( (resp  :Array<ComprobanteE>)  => {
                this.comprobantes = resp;
            })
          }
          else{
            Swal.fire({
              type: 'error',
              title: 'El registro no se pudo guardar'
            })
          }
        });
    }
  }

  
}
